<mat-card>{{'categories' | translate}}</mat-card>



<div class="container" style="padding: 25px;">

  <mat-grid-list cols="4" rowHeight="50px">

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'role' | translate}}</mat-label>
        <mat-select [(value)]="selectedRole" (selectionChange)="OnSelectedRole()">
          <mat-option *ngFor="let role of roles" [value]="role.id">
            {{role.name | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'customers' | translate}}</mat-label>
        <mat-select [(value)]="selectedUser" (selectionChange)="OnSelectedUser()">
          <mat-option *ngFor="let user of users" [value]="user.id">
            {{user.fullName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'menu' | translate}} </mat-label>
        <mat-select [(value)]="selectedMenu" (selectionChange)="OnSelectedMenu()">
          <mat-option *ngFor="let item of menus" [value]="item.id">
            {{item.name | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>


    <mat-grid-tile>
      <button mat-raised-button color="primary" (click)="save()">
        <mat-icon>save</mat-icon>
        {{'submit' | translate}}
      </button>
    </mat-grid-tile>

  </mat-grid-list>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="menuItemId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'id' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.menuItemId}} </td>
      </ng-container>

      <ng-container matColumnDef="menuItemName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'name' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.menuItemName | translate}} </td>
      </ng-container>

      <ng-container matColumnDef="view">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'select' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox class="example-margin" [(ngModel)]="row.view"></mat-checkbox>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}</td>
      </tr>
    </table>

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>